var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "VPopup",
    {
      ref: "popup",
      staticClass: "custom-black-list-settings",
      attrs: { fixed: "", lazy: false, "trigger-element": _vm.triggerElement },
      model: {
        value: _vm.open,
        callback: function ($$v) {
          _vm.open = $$v
        },
        expression: "open",
      },
    },
    [
      _c(
        "div",
        { staticClass: "black-list-settings-header" },
        [
          _c("VIcon", {
            staticClass: "title-icon",
            attrs: { icon: "mdi-sort", size: 24 },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.titleName) + "黑名单设置"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "grow" }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "close",
              on: {
                click: function ($event) {
                  _vm.open = false
                },
              },
            },
            [_c("VIcon", { attrs: { icon: "close", size: 18 } })],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "black-list-settings-content" }, [
        _c("div", { staticClass: "black-list-settings-section" }, [
          _c("div", { staticClass: "black-list-settings-section-title" }, [
            _vm._v("添加到黑名单"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "black-list-settings-section-input" },
            [
              _c("TextBox", {
                attrs: { text: _vm.name },
                on: { change: _vm.changeName },
              }),
              _vm._v(" "),
              _c("VButton", { on: { click: _vm.add } }, [_vm._v("添加")]),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "black-list-settings-section" },
          [
            _c("div", { staticClass: "black-list-settings-section-title" }, [
              _vm._v("黑名单列表"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "black-list-settings-section-description" },
              [_vm._v("点击×图标可以删除名单.")]
            ),
            _vm._v(" "),
            !_vm.loaded ? _c("VLoading") : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.loaded,
                    expression: "loaded",
                  },
                ],
                ref: "black-listSortList",
                staticClass:
                  "black-list-settings-section-content black-list-sort-list",
              },
              _vm._l(_vm.list, function (item) {
                return _c(
                  "div",
                  {
                    key: item,
                    staticClass: "black-list-sort-item",
                    attrs: { "data-name": item },
                  },
                  [
                    _c("div", { staticClass: "item-name" }, [
                      _vm._v("\n            " + _vm._s(item) + "\n          "),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "toggle-visible" },
                      [
                        _c("VIcon", {
                          attrs: { size: 18, icon: "close" },
                          on: {
                            click: function ($event) {
                              return _vm.toggleVisible(item)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                )
              }),
              0
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }